import { render, staticRenderFns } from "./AddGenreModal.vue?vue&type=template&id=0e680b72&scoped=true&"
import script from "./AddGenreModal.vue?vue&type=script&lang=js&"
export * from "./AddGenreModal.vue?vue&type=script&lang=js&"
import style0 from "./AddGenreModal.vue?vue&type=style&index=0&id=0e680b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e680b72",
  null
  
)

export default component.exports